import { render, staticRenderFns } from "./CDR.vue?vue&type=template&id=1855aa0e&scoped=true"
import script from "./CDR.vue?vue&type=script&lang=js"
export * from "./CDR.vue?vue&type=script&lang=js"
import style0 from "./CDR.vue?vue&type=style&index=0&id=1855aa0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1855aa0e",
  null
  
)

export default component.exports